import ReactImageVideoLightbox from 'react-image-video-lightbox'

import { CoverBackground } from 'components/CoverBackground'
import { PropertyHearth } from 'components/Property'
import { ComponentType, useRef, useState } from 'react'
import Lightbox from 'react-image-lightbox'
import Slider from 'react-slick'
import { up } from 'styled-breakpoints'
import styled from 'styled-components'
import { breakpoints } from 'theme'
import { Promo } from 'views/property/promo'

const Wrapper = styled.div`
  margin: 0 -15px;
  padding-bottom: 40px;
  overflow: hidden;

  ${up('sm')} {
    padding-top: 32px;
    padding-bottom: 32px;
    margin: 0;
  }
`

const LightboxLayer = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1030;
  display: flex;
  flex-direction: column;
  background: rgba(0, 0, 0, 0.2);
`

const Content = styled.div`
  position: relative;
  overflow: hidden;
`

const Image = styled(CoverBackground)`
  outline: none;
  height: 410px;

  ${up('sm')} {
    height: 520px;
    border-radius: 10px;
  }
`

const Thumbnail = styled.div`
  padding: 0 3px;
  outline: none;
`

const ThumbnailImage = styled(CoverBackground)`
  height: 68px;
  border-radius: 3px;

  ${up('sm')} {
    height: 82px;
    border-radius: 5px;
  }
`

interface Props {
  property: any
}

export const Gallery: ComponentType<Props> = ({ property }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [index, setIndex] = useState(0)

  const [slider1, setSlider1] = useState<Slider | null>(null)
  const [slider2, setSlider2] = useState<Slider | null>(null)

  const state = useRef({ x: 0 })
  const gallery = property.gallery ?? []

  if (gallery.length) {
    return (
      <>
        {/* {isOpen && (
          <Lightbox
            mainSrc={gallery[index].secureUrl}
            nextSrc={gallery[(index + 1) % gallery.length].secureUrl}
            prevSrc={gallery[(index + gallery.length - 1) % gallery.length].secureUrl}
            imageCaption={gallery[index].title}
            reactModalStyle={{
              overlay: { zIndex: 1050 },
            }}
            onCloseRequest={() => {
              setIsOpen(false)
              setIndex(0)
            }}
            onMovePrevRequest={() => {
              setIndex((index + gallery.length - 1) % gallery.length)
            }}
            onMoveNextRequest={() => {
              setIndex((index + 1) % gallery.length)
            }}
          />
        )} */}
        <Wrapper>
          <Content>
            <Promo property={property} />
            <span>
              <PropertyHearth property={property} />
            </span>
            <Slider ref={(node) => setSlider1(node)} asNavFor={slider2 ?? undefined} className="gallery-hero">
              {gallery.map((media: any, index: number) => {
                return media.type == 'photo' ? (
                  <Image
                    key={media.uuid}
                    url={media.secureUrl}
                    onClick={(event) => {
                      const delta = Math.abs(event.screenX - state.current.x)

                      if (delta > 10) {
                        return
                      }

                      setIndex(index)
                      setIsOpen(true)
                    }}
                    onMouseDown={(event) => {
                      state.current.x = event.screenX
                    }}
                  />
                ) : (
                  <iframe
                    key={media.uuid}
                    height="420"
                    src={media.secureUrl.replace(/watch\?v=/, 'embed\//')}
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;"
                    allowFullScreen></iframe>
                )
              }
              )}
            </Slider>
            {gallery.length > 1 && slider1 && (
              <Slider
                ref={(node) => setSlider2(node)}
                asNavFor={slider1}
                className="gallery-slider"
                slidesToShow={Math.min(Math.max(gallery.length, 3), 7)}
                swipe={false}
                focusOnSelect={true}
                centerMode={true}
                responsive={[
                  {
                    breakpoint: breakpoints.sm,
                    settings: {
                      slidesToShow: Math.min(Math.max(gallery.length, 1), 3),
                      swipe: false,
                      focusOnSelect: true,
                      centerMode: true,
                    },
                  },
                ]}
              >
                {gallery.map((media: any, index: any) => (
                  <Thumbnail key={media.uuid} className={'thumbnail-all thumbnail-' + index} >
                    <ThumbnailImage url={media.thumbnailUrl} />
                  </Thumbnail>
                ))}
              </Slider>
            )}
          </Content>
        </Wrapper>
        {isOpen && (
          <LightboxLayer>
            <ReactImageVideoLightbox
              className="z-[300]"
              data={gallery.map((media: any, index: any) => ({
                url: media.secureUrl.replace(/watch\?v=/, 'embed/'),
                type: media.type
              }))}
              startIndex={index}
              showResourceCount={true}
              onCloseCallback={() => {
                setIsOpen(false)
                setIndex(0)
              }}
              onNavigationCallback={(currentIndex: any) =>
                setIndex(currentIndex)
              }
            />
          </LightboxLayer>
        )}
      </>
    )
  }

  return null
}
